<template>
  <section class="about" id="about">
    <h1 class="heading">about <span> me </span></h1>

    <div class="row-1">
      <div class="image">
        <!-- <img src="@/assets/images/about-img.jpg" alt="" /> -->
        <img src="@/assets/images/Developer_Outline.png" alt="" />
      </div>

      <div class="content">
        <h3>Kemal Beler</h3>
        <p>I am trying to be a good developer</p>
        <p>
          After trying to learn Java and Python languages for a while, I chose
          the field of web development and decided to learn HTML, CSS and
          Javascript. After trying Angular, React and Vue libraries in the JS
          ecosystem for a while, I continued with Vue. After developing projects
          and a mobile application with Vue, I started doing projects with
          React. Finally, I am trying to develop projects with React Native.
        </p>
        <p>
          You can reach some of the projects I have done so far in the portfolio
          section and more on my github page. Apart from these, I would be happy
          to answer your questions, thank you for visiting my website.
        </p>
        <div class="box-container">
          <div class="box">
            <p><span> age : </span> 44</p>
            <p><span> gender : </span> male</p>
            <p><span> language : </span> turkish, english</p>
          </div>
          <div class="box">
            <p><span> work : </span> front-end developer</p>
            <!-- <p><span> freelance : </span> available</p> -->
            <!-- <p><span> phone : </span> +123-456-7890</p> -->
            <!-- <p><span> email : </span> kbeler@outlook.com</p> -->
            <p><span> country : </span> Turkey</p>
          </div>
        </div>
        <a
          :href="require('../assets/YKBResume.pdf')"
          class="btn"
          download="YKBResume.pdf"
          >download my CV</a
        >

        <!--  <a href="#" class="btn">hire me</a> -->
      </div>
    </div>
    <br /><br />
    <br />
    <h1 class="heading"><span> my </span> skills</h1>

    <div class="row-2">
      <!-- <div class="skills">
        <div class="progress">
          <h3>web design <span> 95% </span></h3>
          <div class="bar"><span></span></div>
        </div>
        <div class="progress">
          <h3>web development <span> 80% </span></h3>
          <div class="bar"><span></span></div>
        </div>
        <div class="progress">
          <h3>UI design <span> 75% </span></h3>
          <div class="bar"><span></span></div>
        </div>
        <div class="progress">
          <h3>seo marketing <span> 85% </span></h3>
          <div class="bar"><span></span></div>
        </div>
      </div> -->

      <div class="box-container">
        <div class="box" v-for="skill in skills" :key="skill">
          <!-- <h3>>> 2+</h3> -->
          <!-- <p>years of experience</p> -->
          <!-- <img src="../assets/images/img-2.jpg" alt="" /> -->
          <!-- <h3>{{ skill }}</h3> -->
          <img :src="skill.logo" alt="" />
        </div>
        <!-- <div class="box">
          <h3>>> 250+</h3>
          <p>happy clients</p>
        </div> -->
      </div>
    </div>
  </section>
</template>
<script>
import skills from "../composables/Skills";
export default {
  data() {
    return {
      skills,
    };
  },
};
</script>
